import React from 'react';
import PropTypes from 'prop-types';
import { Backdrop, CircularProgress, Grid, styled } from '@mui/material';

const StyledBackdrop = styled(Backdrop)(({ theme }) => ({
  zIndex: theme.zIndex.drawer + 1,
  color: theme.palette.common.white
}));

const CustomBackdrop = ({ message, open }) => {
  return (
    <StyledBackdrop open={open}>
      <Grid container>
        <Grid item container xs={12} justifyContent='center'>
          <CircularProgress color='inherit' />
        </Grid>
        <Grid item container xs={12} justifyContent='center'>
          {message}
        </Grid>
      </Grid>
    </StyledBackdrop>
  );
};

CustomBackdrop.propTypes = {
  message: PropTypes.string,
  open: PropTypes.bool
};

export default CustomBackdrop;
